import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DetectDeviceTypeService {
    getDeviceType(): 'ios' | 'android' | 'desktop' {
        const ua = navigator.userAgent;

        if (/Android/i.test(ua)) {
            return 'android';
        } else if (/iPhone|iPad|iPod/i.test(ua)) {
            return 'ios';
        }

        return 'desktop';
    }
}
